import { defineMessages } from 'react-intl';

export const splitButtonSpotlightMessages = defineMessages({
	commonConfirm: {
		id: 'create-blank-fabric-page.universal-create.split-button-spotlight.common.confirm',
		defaultMessage: 'OK',
		description: 'Acknowledgement button label in the split-button Universal Create spotlight.',
	},
	commonConfirmSecond: {
		id: 'create-blank-fabric-page.universal-create.split-button-spotlight.common.confirm-second',
		defaultMessage: 'Got it',
		description:
			'Alternative acknowledgement button label in the split-button Universal Create spotlight.',
	},
	commonCreateWithRovo: {
		id: 'create-blank-fabric-page.universal-create.split-button-spotlight.common.create-with-rovo',
		defaultMessage: 'Create with Rovo',
		description: 'Shared Create with Rovo label in the split-button Universal Create spotlight.',
	},
	commonTitle: {
		id: 'create-blank-fabric-page.universal-create.split-button-spotlight.common.title',
		defaultMessage: 'We’re evolving how work starts',
		description: 'Shared title for split-button Universal Create spotlight variants.',
	},
	cwrModalBodyFirst: {
		id: 'create-blank-fabric-page.universal-create.split-button-spotlight.cwr-modal.body-first',
		defaultMessage: 'Choose <b>Create</b> to get started instantly with Rovo’s help.',
		description:
			'First paragraph for the CWR modal button spotlight variant in split-button Universal Create.',
	},
	cwrModalBodySecond: {
		id: 'create-blank-fabric-page.universal-create.split-button-spotlight.cwr-modal.body-second',
		defaultMessage: 'Or select the dropdown to start a new doc, whiteboard, database, or slides.',
		description:
			'Second paragraph for the CWR modal button spotlight variant in split-button Universal Create.',
	},
	ucDropdownBodyFirst: {
		id: 'create-blank-fabric-page.universal-create.split-button-spotlight.uc-dropdown.body-first',
		defaultMessage: 'Use the dropdown for a new doc, whiteboard, database, or slides.',
		description:
			'First paragraph for the UC dropdown spotlight variant in split-button Universal Create.',
	},
	ucDropdownBodySecond: {
		id: 'create-blank-fabric-page.universal-create.split-button-spotlight.uc-dropdown.body-second',
		defaultMessage: 'Or choose <b>Create</b> to get started instantly with Rovo’s help.',
		description:
			'Second paragraph for the UC dropdown spotlight variant in split-button Universal Create.',
	},
});
